/**
 * Guarantor / subscriber flags by client id (demo). Medplum Patient ids use hash fallback when not in overrides.
 */

export interface BillingRoles {
  isGuarantor: boolean;
  isSubscriber: boolean;
}

const OVERRIDES: Record<string, BillingRoles> = {
  '11111111-1111-4111-a111-111111111111': { isGuarantor: true, isSubscriber: true },
  '22222222-2222-4222-a222-222222222222': { isGuarantor: false, isSubscriber: true },
  '33333333-3333-4333-a333-333333333333': { isGuarantor: true, isSubscriber: false },
  '4': { isGuarantor: true, isSubscriber: false },
  '5': { isGuarantor: false, isSubscriber: false },
  '6': { isGuarantor: true, isSubscriber: true },
  '7': { isGuarantor: false, isSubscriber: true },
  '9': { isGuarantor: true, isSubscriber: false },
  '10': { isGuarantor: false, isSubscriber: false },
  '11': { isGuarantor: true, isSubscriber: true },
  '12': { isGuarantor: false, isSubscriber: true },
  '13': { isGuarantor: true, isSubscriber: false },
  '14': { isGuarantor: false, isSubscriber: false },
  '15': { isGuarantor: true, isSubscriber: true },
  '16': { isGuarantor: false, isSubscriber: true },
  '17': { isGuarantor: true, isSubscriber: false },
  '18': { isGuarantor: false, isSubscriber: false },
  'couples-a': { isGuarantor: true, isSubscriber: false },
  'couples-b': { isGuarantor: false, isSubscriber: true },
  '1': { isGuarantor: false, isSubscriber: true },
  '2': { isGuarantor: true, isSubscriber: false },
  '3': { isGuarantor: false, isSubscriber: false },
};

function hashId(id: string): number {
  let h = 0;
  for (let i = 0; i < id.length; i += 1) {
    h = (h * 31 + id.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

function defaultRolesForId(id: string): BillingRoles {
  const h = hashId(id);
  return {
    isGuarantor: h % 3 !== 0,
    isSubscriber: h % 4 !== 0,
  };
}

export function getBillingRoles(clientId: string): BillingRoles {
  return OVERRIDES[clientId] ?? defaultRolesForId(clientId);
}
